import React from "react";
import PropTypes from "prop-types";
import { Scope } from "informed";

import { Container, Item, TabBar, Title } from ".";

const Navigation = props => {
	const { scopePicked } = props;
	let content = null;

	switch (scopePicked) {
		case "container":
			content = <Container />;
			break;
		case "subItem":
		case "item":
			content = <Item {...props} />;
			break;
		case "tabBar":
			content = <TabBar />;
			break;
		case "title":
			content = <Title />;
			break;
		default:
			break;
	}

	return <Scope scope={scopePicked === "tabBar" ? "tabBar" : "navigation"}>{content}</Scope>;
};

Navigation.propTypes = {
	checkForEmptyValue: PropTypes.func.isRequired,
	primaryState: PropTypes.string.isRequired,
	scopePicked: PropTypes.string.isRequired,
	themeData: PropTypes.object.isRequired,
};

export default Navigation;
